import { QueryClient } from "@tanstack/react-query";

/**
 * The app's single QueryClient.
 *
 * It lives here rather than in AppProvider so that non-component modules can
 * reach it without importing a component. `context/auth.ts` clears this cache on
 * logout, and importing AppProvider from the auth store would close a cycle
 * (AppProvider → components → hooks → api-client → auth).
 */
export const queryClient = new QueryClient();
